<!--dynamic data START-->
<div [ngSwitch]="column.template.id">
  <ng-template [ngSwitchCase]="'GENERIC'">
    <div
      *ngIf="column.path === 'formattedId'"
      class="cursor-pointer"
      (click)="orderIdClicked(order)"
    >
      {{ printData(order, column.path) ? printData(order, column.path) : "-" }}
    </div>
    <div *ngIf="column.path != 'formattedId'">
      {{ printData(order, column.path) ? printData(order, column.path) : "-" }}
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'GENERIC_DATE'">
    <div>
      {{
        printData(order, column.path)
          ? (printData(order, column.path) | date: "dd MMM, yyyy")
          : "-"
      }}
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'ADDRESS'">
    <div class="address-box line-2">
      <div *ngIf="!order.saleOrder && order.orderType === 'DROP'">-</div>
      <div
        *ngIf="!order.saleOrder && order.orderType === 'PICKUP'"
        [pTooltip]="order?.fromLocation?.addressInfo | address"
        tooltipStyleClass="tooltip-bg-white"
      >
        {{ order?.fromLocation?.name }} <br />{{
          order?.fromLocation?.addressInfo
            ? (order?.fromLocation?.addressInfo | address)
            : "-"
        }}
      </div>
      <div
        *ngIf="order.saleOrder"
        [pTooltip]="order?.toLocation?.addressInfo | address"
        tooltipStyleClass="tooltip-bg-white"
      >
        {{ order?.toLocation?.name }}<br />{{
          order?.toLocation?.addressInfo
            ? (order?.toLocation?.addressInfo | address)
            : "-"
        }}
      </div>
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'CITY_NAME'">
    <div class="address-box line-2">
      <div *ngIf="!order.saleOrder && order.orderType === 'DROP'">-</div>
      <div
        *ngIf="!order.saleOrder && order.orderType === 'PICKUP'"
        [pTooltip]="order?.fromLocation && order?.fromLocation?.addressInfo | address"
        tooltipStyleClass="tooltip-bg-white"
      >
        {{
          order?.fromLocation && order?.fromLocation?.addressInfo
            ? order?.fromLocation?.addressInfo?.city?.name
            : "-"
        }}
      </div>
      <div
        *ngIf="order.saleOrder"
        [pTooltip]="
          order?.toLocation && order?.toLocation?.addressInfo | address
        "
        tooltipStyleClass="tooltip-bg-white"
      >
        {{
          order?.toLocation && order?.toLocation?.addressInfo
            ? order?.toLocation?.addressInfo?.city?.name
            : "-"
        }}
      </div>
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'FROM_LOCATION'">
    <div class="address-box line-2">
      <div
        *ngIf="order?.fromLocation?.addressInfo"
        [pTooltip]="order?.fromLocation?.addressInfo | address"
        tooltipStyleClass="tooltip-bg-white"
      >
        {{ order?.fromLocation?.name }}<br />{{
          order?.fromLocation?.addressInfo
            ? (order?.fromLocation?.addressInfo | address)
            : "-"
        }}
      </div>
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'RECEIVED_LOCATION'">
    <div class="address-box line-2">
      <div
        [pTooltip]="order?.toLocation?.addressInfo | address"
        tooltipStyleClass="tooltip-bg-white"
      >
        {{ order?.toLocation?.name }}<br />{{
          order?.toLocation?.addressInfo
            ? (order?.toLocation?.addressInfo | address)
            : "-"
        }}
      </div>
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'QUANTITY'">
    <div>
      {{
        printData(order, column.path)
          ? printData(order, column.path) + " Kgs"
          : "-"
      }}
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'EMAIL'">
    <div *ngIf="!order.saleOrder && order.orderType === 'DROP'">
      {{ order.seller?.email || "-" }}
    </div>
    <div *ngIf="!order.saleOrder && order.orderType === 'PICKUP'">
      {{ order.fromLocation?.email || "-" }}
    </div>
    <div *ngIf="order.saleOrder">{{ order.buyer?.email || "-" }}</div>
  </ng-template>

  <ng-template [ngSwitchCase]="'STATUS'">
    <div class="status-display">
      <div
        class="status-dot {{
          order.displayStatusTitle === 'Completed'
            ? order.paymentStatus
              ? order.paymentStatus.toLowerCase()
              : '-'
            : order.displayStatusTitle.replace(' ', '_').toLowerCase()
        }}"
      ></div>
      <div>
        {{
          order.displayStatusTitle === "Completed"
            ? order.paymentStatus
              ? order.paymentStatus.split("_").join(" ").toLowerCase()
              : "-"
            : order.displayStatusTitle
        }}
      </div>
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'CONTACT'">
    <div *ngIf="!order.saleOrder && order.orderType === 'DROP'">
      {{ order.seller?.mobile || "-" }}
    </div>
    <div *ngIf="!order.saleOrder && order.orderType === 'PICKUP'">
      {{ order.fromLocation?.contactNumber || "-" }}
    </div>
    <div *ngIf="order.saleOrder">{{ order.buyer?.mobile || "-" }}</div>
  </ng-template>

  <ng-template [ngSwitchCase]="'EXECUTIVE'">
    <div>
      <div *ngIf="order.pickupPerson">
        <div *ngIf="order.pickupPerson">
          {{ order.pickupPerson?.userName || "-" }}
        </div>
        <div *ngIf="order.pickupPerson">
          {{ order.pickupPerson?.mobileNumber || "-" }}
        </div>
      </div>
      <div *ngIf="!order.pickupPerson">-</div>
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'DELAY'">
    <div class="delay-column">
      {{
        order.delay ? order.delay + (order.delay === 1 ? " Day" : " Days") : "-"
      }}
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'CURRENCY'">
    <div>
      {{
        printData(order, column.path)
          ? (printAsAbs(printData(order, column.path)) | currency: "INR")
          : 0
      }}
    </div>
  </ng-template>

  <ng-template [ngSwitchCase]="'BUSINESS_TYPE'">
    <div class="bgtype">
      <span
        *ngIf="!order.saleOrder"
        class="{{ order.seller?.businessType?.code || '' }}"
        >{{ order.seller?.businessType?.title || "-" }}</span
      >
      <span
        *ngIf="order.saleOrder"
        class="{{ order.buyer?.businessType?.code || '' }}"
        >{{ order.buyer?.businessType?.title || "-" }}</span
      >
    </div>
  </ng-template>
</div>
